// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M7.5 2.71741L2 5.92575V21.5001L7.5 19.2328V2.71741Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M9.5 18.9097L11.5 20.0908V11.5H14.5V5.09051L9.5 2.1377V18.9097Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 2.50012V11.5H16.5V4.76744L22 2.50012Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M23 13.5H13.5L13.5 22.5174L17.7075 20.4971L23 20.4971V13.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-map-chat-filled')
export default class MapChatFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'map-chat-filled',
    }
  }
}
